import { format as formatFunction, formatISO, parseISO } from 'date-fns';

const formatDateTime = (date: string | undefined, format: string, valueIfEmpty = '-'): [string, boolean] => {
  let hasValue: boolean;
  let formattedDate: string;

  if (date && date.trim().length > 0) {
    hasValue = true;
    formattedDate = formatFunction(new Date(date), format);
  } else {
    hasValue = false;
    formattedDate = valueIfEmpty;
  }

  return [
    formattedDate,
    hasValue
  ];
}

const formatISODateTime = (date?: Date | number): string | undefined => {
  if (date) {
    return formatISO(date);
  }

  return undefined;
}

const parseISODateTime = (date?: string): Date | undefined => {
  if (date) {
    return parseISO(date);
  }

  return undefined;
}

const parseDateWithTimezone = (date: Date, format: string): string => {
  const dateWithUTCIndicator = new Date(date + 'Z');
  return formatFunction(dateWithUTCIndicator, format);
}

const getTimeZone = (): string => {
    const offsetMinutes = new Date().getTimezoneOffset();
    const offsetHours = Math.floor(Math.abs(offsetMinutes) / 60);
    const offsetMins = Math.abs(offsetMinutes) % 60;
    const sign = offsetMinutes <= 0 ? '+' : '-';
    const timeZone = `GMT${sign}${offsetHours.toString().padStart(2, '0')}:${offsetMins.toString().padStart(2, '0')}`;
    return timeZone;
}

export const DateTimeUtils = {
    format: formatDateTime,
    formatISO: formatISODateTime,
    parseISO: parseISODateTime,
    parseDateWithTimezone: parseDateWithTimezone,
    getTimeZone: getTimeZone,
}